<template>
  <div>
    <topNav></topNav>
    <div class="top"></div>
    <div style="background-color: #f4f4f4 ;padding-top: 60px;">
      <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>投资者保护渠道</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
          </div>
      <div class="grid">
        <div class="gridCli">
          <div class="cliA" id="icon1"></div>
          <div class="cliB">联系德讯证顾</div>
          <div class="cliC">客服电话：400-636-8688</div>
          <div class="cliC">投保电话：0755-33189899</div>
        </div>
        <div class="gridCli">
          <div class="cliA" id="icon2"></div>
          <div class="cliB">联系德讯算法</div>
          <div class="cliC">客服电话：400-803-0899</div>
          <!-- <div class="cliC">-联系客服</div> -->
        </div>
        <div class="gridCli">
          <div class="cliA" id="icon3"></div>
          <div class="cliB">官方APP</div>
          <div class="cliC">股信 - 德讯智能小秘书</div>
          <div class="cliC">-人工客服</div>
        </div>
        <div class="gridCli">
          <div class="cliA" id="icon4"></div>
          <div class="cliB">投保邮箱</div>
          <div class="cliC">33189899@dexunzhenggu.cn</div>
        </div>
        <div class="gridCli">
          <div class="cliA" id="icon5"></div>
          <div class="cliB">信函地址</div>
          <div class="cliC" id="cliC">
            广东省深圳市罗湖区笋岗街道田贝社区洪湖二街50号新南滨大厦3层（德讯证顾-投资者保护中心收）
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>投资者保护工作流程</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
          </div>
      <div class="lc"></div>
    </div>
    <Bottoms></Bottoms>

  </div>
</template>
<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
export default {
  name: "investCenter",
  components: { topNav, Bottoms },
  mounted(){
    window.scrollTo(0, 0);
    var index = this.$route.query.index
    console.log(this.$route.query)
    if (index == 1) {
    window.scrollTo(0, 450);
    } else if(index == 2){
    window.scrollTo(0, 950);
    }

  }
};
</script>
<style scoped>
.top {
  width: 100%;
  height: 400px;
  /* background: blue; */
  background: url("../common/images/investCenter/top.png") no-repeat;
  background-size: 100% 100%;
  opacity: 1;
}
.title {
  position: relative;
  width: 1226px;
  height: 100px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  font-size: 40px;
  text-align: center;
  line-height: 166px;
  margin: 0px auto 0px;
  
}
 .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
 .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.grid {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 350px;
justify-content: center;
  background: rgba(244, 244, 244, 0.39);
}
.gridCli {
  box-sizing: border-box;

  display: inline-block;
  width: 260px;
  height: 286px;
  /* background: rgba(255, 255, 255, 0.39); */
  background-color: #fff;
  border: 1px solid #ebebeb;
  opacity: 1;
  border-radius: 6px;
  margin-right: 10px;
}
#icon1 {
  background: url("../common/images/investCenter/icon1.png") no-repeat;
}
#icon2 {
  background: url("../common/images/investCenter/icon2.png") no-repeat;
}
#icon3 {
  width: 100px;
  height: 100px;
  margin: 32px 0 0 80px;

  background: url("../common/images/investCenter/icon3.png") no-repeat;
}
#icon4 {
  background: url("../common/images/investCenter/icon4.png") no-repeat;
}
#icon5 {
  background: url("../common/images/investCenter/icon5.png") no-repeat;
}
.cliA {
  width: 96px;
  height: 96px;
  opacity: 1;
  background-color: blue;
  margin: 34px 0 0 82px;
}
.cliB {
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 33px;
  color: #333333;
  opacity: 1;
  margin: 26px 0 16px 0;
}
.cliC {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #666666;
  opacity: 1;
  margin-bottom: 10px;
}
#cliC {
  font-size: 14px;
  line-height: 20px;
  padding: 0 13px 0 12px;
}
.content {
  width: 100%;
  height: 1571px;
  background-color: #ffffff;
  padding-top: 60px;
}
#lc {
  background-color: #ffffff;
}
.lc {
  width: 1200px;
  height: 1416px;
  margin: -6px auto 0;
  background: url("../common/images/investCenter/lc.png") no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/investCenter.vue